const WB_TITLE = 'wb_title';
const WB_SUBTITLE = 'wb_subtitle';

export {
  WB_TITLE,
  WB_SUBTITLE,
};
